export default __webpack_public_path__ + "static/media/dashboard.b7206900.svg";